import * as React from 'react';
import { IconProps } from '../types';

const IcGrid = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M3.783 3.5v6.09h6.09V3.5h-6.09Zm-.5-1.5a1 1 0 0 0-1 1v7.09a1 1 0 0 0 1 1h7.09a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-7.09ZM3.783 14.41v6.09h6.09v-6.09h-6.09Zm-.5-1.5a1 1 0 0 0-1 1V21a1 1 0 0 0 1 1h7.09a1 1 0 0 0 1-1v-7.09a1 1 0 0 0-1-1h-7.09ZM14.692 3.5v6.09h6.09V3.5h-6.09Zm-.5-1.5a1 1 0 0 0-1 1v7.09a1 1 0 0 0 1 1h7.09a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-7.09ZM14.692 14.41v6.09h6.09v-6.09h-6.09Zm-.5-1.5a1 1 0 0 0-1 1V21a1 1 0 0 0 1 1h7.09a1 1 0 0 0 1-1v-7.09a1 1 0 0 0-1-1h-7.09Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcGrid;